import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { InputComponent } from '../../../components/form/input/input.component';

@Component({
  selector: 'app-login-private',
  standalone: true,
  imports: [CommonModule, InputComponent],
  templateUrl: './login-local.component.html',
  styleUrl: './login-local.component.scss'
})
export class LoginLocalComponent {
  loginError = '';
  passwordError = '';
  username = '';
  password = '';
  labelUser = $localize`:@@Login.User:USUARIO`;
  labelPassword = $localize`:@@Login.Password:CONTRASEÑA`;
  placeUser = $localize`:@@Login.PlaceUser:NIF, NIE, Pasaporte`;
  placePass = $localize`:@@Login.PlacePass:Contraseña`;

  constructor(private authService: AuthService, private router: Router) {}

  async login() {
    this.loginError = '';
    this.passwordError = '';
    if (this.username === '') {
      this.loginError = $localize`:@@Login.ErrorUser:El usuario no puede estar vacío`;
    }
    if (this.password === '') {
      this.passwordError = $localize`:@@Login.ErrorPass:La contraseña no puede estar vacía`;
    }
    if (this.loginError === '' && this.passwordError === '') {
      if (await this.authService.loginUser(this.username, this.password)) {
        if (this.authService.isAdmin()) {
          this.router.navigate(['/requests']);
          return;
        }
        this.router.navigate(['/exceptions']);
      } else {
        this.loginError = $localize`:@@Login.ErrorValidate:El usuario o la contraseña son incorrectos`;
      }
    }
  }
}
